<template>
  <div class="d-flex">
    <v-checkbox
      color="red"
      class="ma-0 pa-0 check-button"
      :ripple="false"
      :input-value="isChecked"
      @change="handleSelectTask"
      hide-details
    >
      <template v-slot:label>
        <div
          class="task-container d-flex flex-column justify-start flex-grow-1"
        >
          <p class="overline font-bold blue--text text--lighten-1 mb-0">
            {{ $t('ai_features.task_number', { number: formattedNumber }) }}
          </p>

          <p
            class="subtitle-2 font-bold blue-grey--text text--lighten-3 ma-0 pa-0"
          >
            {{ taskTitle }}
          </p>

          <p
            v-if="taskDescription"
            class="body-2 blue-grey--text text--lighten-3 mb-0"
          >
            {{ taskDescription }}
          </p>
        </div>
      </template>
    </v-checkbox>
  </div>
</template>

<script>
export default {
  name: 'AiTask',

  props: {
    task: Object,
    taskIndex: Number,
    selectedTasks: Array,
  },

  data() {
    return {}
  },

  computed: {
    taskTitle() {
      return this.task?.title
    },

    taskDescription() {
      return this.task?.description
    },

    formattedNumber() {
      return this.taskIndex + 1 > 9
        ? '' + this.taskIndex + 1
        : '0' + (this.taskIndex + 1)
    },

    isChecked() {
      return this.selectedTasks?.includes(this.taskIndex) ?? false
    },
  },

  methods: {
    handleSelectTask(checkValue) {
      this.$emit('selectTask', checkValue)
    },
  },
}
</script>

<style scoped lang="scss">
.task-container {
  border-radius: 3px;
}

::v-deep .check-button .v-input--selection-controls__input .v-icon {
  color: $color-blue-grey-lighten3 !important;
  margin-top: 30px;
  margin-right: 16px;
}

::v-deep .check-button .v-input__control .v-input__slot {
  align-items: start;
}
</style>
